module.exports = __webpack_public_path__ + "img/todos.b35d078e.jpg";